<template>
  <el-container style="position: relative;">
    <el-aside width="300px">
      <el-card class="base-card" shadow="never" :body-style="{ padding: '0px' }">
        <div slot="header" class="base-card-header">
          <span>产业信息</span>
        </div>
        <el-scrollbar :style="{height: (getMainContextHeight - 94) + 'px'}" class="custom-scroll">
          <el-tree ref="industryLeftTree" :props="{label: 'name'}"
            :data="industryPage.industryLeftTree.impl.dropdownList"
            node-key="id" @node-click="onIndustryLeftTreeValueChange"
            :highlight-current="true" :default-expand-all="false" />
        </el-scrollbar>
      </el-card>
    </el-aside>
    <el-main style="padding-left: 15px;">
      <el-scrollbar :style="{height: (getMainContextHeight - 42) + 'px'}" class="custom-scroll">
        <el-form ref="industryPageFilter" :model="industryPage" :size="defaultFormItemSize"
          label-width="100px" label-position="right" @submit.native.prevent
        >
          <filter-box :item-width="350">
            <el-form-item label="产业名称" prop="formFilter.industryName">
              <el-input class="filter-item" v-model="industryPage.formFilter.industryName"
                :clearable="true" placeholder=""
              />
            </el-form-item>
            <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetIndustryPage">重置</el-button>
            <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshIndustryPage(true)">查询</el-button>
            <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('industryPage:industryPage:industryEditAdd')"
              @click="onIndustryEditAddClick()">
              新增
            </el-button>
          </filter-box>
        </el-form>
        <el-row>
          <el-col :span="24">
            <el-table ref="sysIndustry" :data="industryPage.SysIndustry.impl.dataList" :size="defaultFormItemSize" @sort-change="industryPage.SysIndustry.impl.onSortChange"
              header-cell-class-name="table-header-gray"
              highlight-current-row @current-change="industryPage.SysIndustry.impl.currentRowChange"
            >
              <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="industryPage.SysIndustry.impl.getTableIndex" />
              <el-table-column label="父级产业" prop="parentIndustryIdDictMap.name">
              </el-table-column>
              <el-table-column label="产业名称" prop="industryName">
              </el-table-column>
              <el-table-column label="显示顺序" prop="showOrder">
              </el-table-column>
              <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                  <el-button @click.stop="onIndustryEditClick(scope.row)" type="text" :size="defaultFormItemSize"
                    :disabled="!checkPermCodeExist('industryPage:industryPage:industryEdit')">
                    编辑
                  </el-button>
                  <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                    :disabled="!checkPermCodeExist('industryPage:industryPage:delete')">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-row type="flex" justify="end" style="margin-top: 10px;">
              <el-pagination
                :total="industryPage.SysIndustry.impl.totalCount"
                :current-page="industryPage.SysIndustry.impl.currentPage"
                :page-size="industryPage.SysIndustry.impl.pageSize"
                :page-sizes="[10, 20, 50, 100]"
                layout="total, prev, pager, next, sizes"
                @current-change="industryPage.SysIndustry.impl.onCurrentPageChange"
                @size-change="industryPage.SysIndustry.impl.onPageSizeChange">
              </el-pagination>
            </el-row>
          </el-col>
        </el-row>
      </el-scrollbar>
    </el-main>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SysIndustryController, DictionaryController } from '@/api';
import industryEdit from '@/views/baseInfo/industryEdit.vue';

export default {
  name: 'industryPage',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      industryPage: {
        formFilter: {
          industryLeftTree: undefined,
          industryName: undefined
        },
        formFilterCopy: {
          industryLeftTree: undefined,
          industryName: undefined
        },
        industryLeftTree: {
          impl: new DropdownWidget(this.loadIndustryLeftTreeDropdownList, true, 'id', 'parentId')
        },
        SysIndustry: {
          impl: new TableWidget(this.loadSysIndustryWidgetData, this.loadSysIndustryVerify, true, true, 'showOrder', 1)
        },
        isInit: false
      }
    }
  },
  methods: {
    onResetIndustryPage () {
      this.$refs.industryPageFilter.resetFields();
      this.refreshIndustryPage(true);
    },
    /**
     * 产业表数据获取函数，返回Promise
     */
    loadSysIndustryWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        sysIndustryDtoFilter: {
          parentIndustryId: this.industryPage.formFilterCopy.industryLeftTree,
          industryName: this.industryPage.formFilterCopy.industryName
        }
      }
      return new Promise((resolve, reject) => {
        SysIndustryController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.industryPage.SysIndustry.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.industryPage.SysIndustry.impl.currentRow.industryId, 'industryId');
              this.$refs.sysIndustry.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 产业表数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSysIndustryVerify () {
      this.industryPage.formFilterCopy.industryLeftTree = this.industryPage.formFilter.industryLeftTree;
      this.industryPage.formFilterCopy.industryName = this.industryPage.formFilter.industryName;
      return true;
    },
    /**
     * 产业信息下拉数据获取函数
     */
    loadIndustryLeftTreeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIndustryDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 产业信息选中值改变
     */
    onIndustryLeftTreeValueChange (value) {
      if (value.id !== this.industryPage.formFilter.industryLeftTree) {
        this.industryPage.formFilter.industryLeftTree = value.id;
      } else {
        this.industryPage.formFilter.industryLeftTree = undefined;
        this.$nextTick(() => {
          this.$refs.industryLeftTree.setCurrentKey(null);
        });
      }
      this.refreshIndustryPage(true);
    },
    /**
     * 更新产业管理
     */
    refreshIndustryPage (reloadData = false) {
      if (reloadData) {
        this.industryPage.SysIndustry.impl.refreshTable(true, 1);
      } else {
        this.industryPage.SysIndustry.impl.refreshTable();
      }
      if (!this.industryPage.isInit) {
        // 初始化下拉数据
        this.industryPage.industryLeftTree.impl.onVisibleChange(true);
      }
      this.industryPage.isInit = true;
    },
    /**
     * 新增
     */
    onIndustryEditAddClick () {
      let params = {};

      this.$dialog.show('新增', industryEdit, {
        area: '500px'
      }, params).then(res => {
        this.refreshIndustryPage();
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onIndustryEditClick (row) {
      let params = {
        industryId: row.industryId
      };

      this.$dialog.show('编辑', industryEdit, {
        area: '500px'
      }, params).then(res => {
        this.industryPage.SysIndustry.impl.refreshTable();
      }).catch(e => {});
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        industryId: row.industryId
      };

      SysIndustryController.delete(this, params).then(res => {
        this.$message.success('删除成功');
        this.industryPage.SysIndustry.impl.refreshTable(false, 1);
      }).catch(e => {});
    },
    onResume () {
      this.refreshIndustryPage();
    },
    initFormData () {
    },
    formInit () {
      this.refreshIndustryPage();
    }
  },
  computed: {
    ...mapGetters(['getMainContextHeight'])
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>

<style scoped>
  >>> .el-tree-node__content {
    height: 35px;
  }
</style>
